import { Component, Inject } from '@angular/core';
import { HygieneStaftReportService, StaffAttendanceImage } from '../hygiene-staft-report.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { HygineDayWiseService } from '../hygine-day-wise.service';

interface StaffAttendanceImageGroup {
  departmentName?: string;
  staffCount?: number;
  sessionType?: string;
  imageDetails?: StaffAttendanceImage[];
  campusName?: string;
  buildingName?: string;
  employeeName?: string;
  designation?: string;
  mobileNo?: string;
  /** Campus-level coordinates */
  latitude?: string | number;
  longitude?: string | number;
  /** Building-level coordinates (may differ slightly from campus pin) */
  buildingLatitude?: string | number;
  buildingLongitude?: string | number;
}


export interface HygieneDayWiseImagesDialogData {
  /** YYYY-MM-DD */
  hygieneDate: string;
  campusId: number;
  buildingId?: number | null;
  campusName?: string;
  departmentName?: string;
}


@Component({
  selector: 'app-hygine-day-wise-image',
  templateUrl: './hygine-day-wise-image.component.html',
  styleUrls: ['./hygine-day-wise-image.component.scss']
})
export class HygineDayWiseImageComponent {
  mapIconPath = 'assets/image/college-map-icon.svg';
  /** API can return either flat image list OR grouped list with `imageDetails`. */
  imageGroups: StaffAttendanceImageGroup[] = [];
  selectedGroupIndex = 0;
  loading = true;
  errorMessage = '';
  allImages: StaffAttendanceImage[] = [];
  /** Index of the image shown on the right */
  selectedIndex = 0;
  /** Rotation in degrees for the currently shown image (0, 90, 180, 270) */
  rotationDeg = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: HygieneDayWiseImagesDialogData,
    private dialogRef: MatDialogRef<HygineDayWiseImageComponent>,
    private dayWise: HygineDayWiseService
  ) { }

  get hasImages(): boolean {
    return this.images.length > 0;
  }
get currentImageInfo(): any {
  return this.currentImage?.parent || null;
}
  get images(): StaffAttendanceImage[] {
    const g = this.imageGroups[this.selectedGroupIndex];
    const list = Array.isArray(g?.imageDetails) ? g.imageDetails! : [];
    return list.filter((x) => x && (x.url || '').trim());
  }

  get currentGroup(): StaffAttendanceImageGroup | null {
    return this.imageGroups[this.selectedGroupIndex] ?? null;
  }

  // get currentImage(): StaffAttendanceImage | null {
  //   if (!this.hasImages) return null;
  //   const i = Math.min(Math.max(0, this.selectedIndex), this.images.length - 1);
  //   return this.images[i] ?? null;
  // }

  // get canGoPrev(): boolean {
  //   return !this.loading && !this.errorMessage && this.hasImages && this.selectedIndex > 0;
  // }

  // get canGoNext(): boolean {
  //   return !this.loading && !this.errorMessage && this.hasImages && this.selectedIndex < this.images.length - 1;
  // }
get currentImage(): any {
  return this.allImages?.[this.selectedIndex] || null;
}

get canGoPrev(): boolean {
  return this.selectedIndex > 0;
}

get canGoNext(): boolean {
  return this.selectedIndex < this.allImages.length - 1;
}

prev(): void {
  if (this.canGoPrev) {
    this.selectedIndex--;
  }
}

next(): void {
  if (this.canGoNext) {
    this.selectedIndex++;
  }
}
  ngOnInit(): void {
    this.dayWise
      .getStaffAttendanceImages(this.data.hygieneDate,
        this.data.campusId,
        this.data.buildingId ?? null,
        this.data.departmentName)
      .subscribe({
        next: (raw) => {
          const { groups, error } = this.normalizeApiResponse(raw);
          if (error) {
            this.errorMessage = error;
            this.imageGroups = [];
            this.allImages = [];
          } else {

            this.imageGroups = groups || [];

          this.allImages = [];

          this.imageGroups.forEach(group => {

            (group.imageDetails || []).forEach((img: any) => {

              this.allImages.push({
                ...img,
                parent: group
              });

            });

          });

            console.log('Total Images', this.allImages.length);
          }
          this.selectedGroupIndex = 0;
          this.selectedIndex = 0;
          this.rotationDeg = 0;
          this.loading = false;
        },
        error: () => {
          this.loading = false;
          this.errorMessage = 'Could not load images. Please try again.';
        }
      });
  }

  caption(item: StaffAttendanceImage): string {
    return (item.uploadedTime ?? item.uplodedTime ?? '').trim();
  }

  metaLine(g: StaffAttendanceImageGroup | null): string {
    if (!g) return '';
    const parts = [g.buildingName, g.employeeName, g.designation, g.mobileNo]
      .map((x) => (x ?? '').toString().trim())
      .filter(Boolean);
    return parts.join(' · ');
  }

  hasCampusLocation(g: StaffAttendanceImageGroup | null | undefined): boolean {
    return this.isValidCoordPair(g?.latitude, g?.longitude);
  }

  hasBuildingLocation(g: StaffAttendanceImageGroup | null | undefined): boolean {
    return this.isValidCoordPair(g?.buildingLatitude, g?.buildingLongitude);
  }

  mapPinAriaLabel(g: StaffAttendanceImageGroup | null): string {
    if (!g) return 'Open map';
    if (this.hasBuildingLocation(g)) return 'Open map at building location';
    if (this.hasCampusLocation(g)) return 'Open map at captures location';
    return `Open map for ${(g.buildingName || this.data.campusName || 'location').trim() || 'location'}`;
  }

  private isValidCoordPair(lat: unknown, lng: unknown): boolean {
    if (lat == null || lng == null) return false;
    const a = Number(lat);
    const b = Number(lng);
    return !Number.isNaN(a) && !Number.isNaN(b);
  }

  selectGroup(i: number): void {
    if (this.loading || this.errorMessage) return;
    const idx = Number(i);
    if (Number.isNaN(idx)) return;
    if (idx < 0 || idx >= this.imageGroups.length) return;
    if (idx === this.selectedGroupIndex) return;
    this.selectedGroupIndex = idx;
    this.selectedIndex = 0;
    this.rotationDeg = 0;
  }

  /** Only changes which loaded image is shown — does not call API or change the report date. */
  // prev(): void {
  //   if (this.canGoPrev) {
  //     this.selectedIndex--;
  //     this.rotationDeg = 0;
  //   }
  // }

  // /** Only changes which loaded image is shown — does not call API or change the report date. */
  // next(): void {
  //   if (this.canGoNext) {
  //     this.selectedIndex++;
  //     this.rotationDeg = 0;
  //   }
  // }

  rotateLeft(): void {
    this.rotationDeg = (this.rotationDeg + 270) % 360;
  }

  rotateRight(): void {
    this.rotationDeg = (this.rotationDeg + 90) % 360;
  }

  resetRotation(): void {
    this.rotationDeg = 0;
  }

  close(): void {
    this.dialogRef.close();
  }

  /**
   * Opens Google Maps. `auto` prefers building pin, then campus pin, then text search.
   */
  openMap(mode: 'auto' | 'campus' | 'building' = 'auto'): void {
    const g = this.currentGroup;
    const openCoords = (lat: unknown, lng: unknown): boolean => {
      if (!this.isValidCoordPair(lat, lng)) return false;
      const url = `https://www.google.com/maps?q=${encodeURIComponent(String(lat))},${encodeURIComponent(String(lng))}`;
      window.open(url, '_blank', 'noopener,noreferrer');
      return true;
    };

    if (g) {
      if (mode === 'building') {
        if (openCoords(g.buildingLatitude, g.buildingLongitude)) return;
      } else if (mode === 'campus') {
        if (openCoords(g.latitude, g.longitude)) return;
      } else {
        if (openCoords(g.buildingLatitude, g.buildingLongitude)) return;
        if (openCoords(g.latitude, g.longitude)) return;
      }
    }

    const q = (g?.buildingName || g?.campusName || this.data.campusName || '').trim();
    const url = q
      ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`
      : 'https://www.google.com/maps';
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  private normalizeApiResponse(raw: unknown): { groups: StaffAttendanceImageGroup[]; error?: string } {
    const r = raw as any;
    if (!Array.isArray(r)) {
      return { groups: [], error: 'No images found.' };
    }
    // New API: [{ departmentName, staffCount, sessionType, imageDetails: [{url,uplodedTime|uploadedTime}], ... }]
    if (r.length > 0 && (Array.isArray(r[0]?.imageDetails) || r[0]?.departmentName || r[0]?.sessionType)) {
      const groups: StaffAttendanceImageGroup[] = r.map((g: any) => ({
        departmentName: (g?.departmentName ?? '').toString().trim() || undefined,
        staffCount: g?.staffCount != null ? Number(g.staffCount) : undefined,
        sessionType: (g?.sessionType ?? '').toString().trim() || undefined,
        imageDetails: Array.isArray(g?.imageDetails) ? g.imageDetails : [],
        campusName: (g?.campusName ?? '').toString().trim() || undefined,
        buildingName: (g?.buildingName ?? '').toString().trim() || undefined,
        employeeName: (g?.employeeName ?? '').toString().trim() || undefined,
        designation: (g?.designation ?? '').toString().trim() || undefined,
        mobileNo: (g?.mobileNo ?? '').toString().trim() || undefined,
        latitude: g?.latitude ?? g?.lat ?? undefined,
        longitude: g?.longitude ?? g?.lng ?? undefined,
        buildingLatitude: g?.buildingLatitude ?? undefined,
        buildingLongitude: g?.buildingLongitude ?? undefined
      }));
      return { groups };
    }

    // Old API: [{ url, uplodedTime | uploadedTime }]
    const flat: StaffAttendanceImage[] = r;
    return { groups: [{ imageDetails: flat }] };
  }


}
